import ImgProxy from "@jsmonday/imgproxy"
import {Storage} from "aws-amplify"
import {v4 as uuidv4} from "uuid"
import aws from "../aws-exports"
import {SubmissionItem} from "../stores/SubmissionItem";

export class ImageOpts {
  constructor(
    public maxWidth: number = undefined,
    public maxHeight: number = undefined,
    public fitMode: undefined | "fit" | "fill" | "auto" = "fit"
  ) {
  }
}

export type Progress = {
  id: string
  started: number
  name: string
  done: number
  total: number
  finished: boolean
}

export type ImageRef = {
  url: string
  width: number
  height: number
}

export type UploadResult = {
  url: string
  contentType: string
  name: string
  key: string
}

export class ImageApi {
  static imgProxy = new ImgProxy({
    key:
      "89b2f33764bfd833994183803532a22959505ed2815aa6da875832bef121d820513b89582c35302f03466a8d917293bedf3ed40b44ef3e31cefc8ba811e997f3",
    salt:
      "1fec63382cb7f0f894d731a5693538727965a72d9f10d222ecfb7788bc1c79fba5a9b392824ad35b596af6c9885edc87e38808747452580315c6af9337cce084",
    url: "https://dj7e06afrh6zh.cloudfront.net",
  })

  static resizedItemMedia = (item: SubmissionItem) => (opts: ImageOpts) =>
    ImageApi.resized(item.url, item.contentType)(opts)

  static resized = (url: string, contentType: string) => (opts: ImageOpts) => {
    if (contentType.startsWith("video")) {
      return {
        url: 'http://simpleicon.com/wp-content/uploads/film-3.png',
        width: opts.maxWidth,
        height: opts.maxHeight
      }
    }

    const newVar = ImageApi.imgProxy
      .image(url)
      .width(opts.maxWidth)
      .resizeType("fit")
      .height(opts.maxHeight)
      .get()

    return {
      url: newVar,
      width: opts.maxWidth,
      height: opts.maxHeight,
    }
  }

  /**
   * Uploads given file to s3.
   *
   * Returns the S3 URI of the uploaded file
   *
   * @param file file to upload
   * @param contentType the MIME content type
   * @param user current user
   * @param progress progress callback
   */

  static upload(
    file: File,
    contentType: string,
    user: string,
    progress: (bytes: number) => void
  ): Promise<UploadResult> {
    return this.store(
      `${uuidv4()}-${file.name}`,
      file,
      contentType,
      progress,
      user
    )
  }

  private static async store(
    id: string,
    file: File,
    contentType: string,
    progress: (bytesUploaded: number) => void,
    user: string
  ): Promise<UploadResult> {
    return Storage.put(id, file, {
      level: "private",
      progressCallback: updatedProgress =>
        progress(
          updatedProgress.loaded
        ),
    }).then(success =>
      ({
        url: `s3://${aws.aws_user_files_s3_bucket}/private/${user}/${success.key}`,
        name: file.name,
        key: id,
        contentType: contentType
      })
    )
  }
}


